import React, { useEffect } from 'react'
import Button from '../../components/Button'
import { SVGInjector } from '@tanem/svg-injector'
import Modal from './Modal'
import { useBootstrapModal } from '../../utils/useForm'

export const useAlertModal = (props) => {
  const alertModal = useBootstrapModal(false)

  const MyHeader = (props) => (
    <h3>{props.text}</h3>
  )

  const MyBody = (props) => (
    <p>{props.text}</p>
  )

  const MyFooter = (props) => {
    const { cancelButtonText, submitButtonText, handleSubmitClick } = props

    const handleClose = (e) => {
      alertModal.closeModal()
    }

    const handleSubmit = (e) => {
      if (handleSubmitClick) {
        handleSubmitClick() // from parent
      }
      alertModal.closeModal()
    }

    useEffect(() => {
      const mySVGsToInject = document.querySelectorAll('img.injectSVG')
      SVGInjector(mySVGsToInject)
    }, [])

    return (
      <>
        <Button variant="tertiary" onClick={handleClose} disabled={false}>
            <span className="material-icons">close</span>
            <span className="button__text">{cancelButtonText}</span>
        </Button>

        <Button variant="primary" onClick={handleSubmit} disabled={false}>
          <span className="material-icons">check</span>
          <span className="button__text">{submitButtonText}</span>
        </Button>
      </>
    )
  }

  const AlertModalView = (props) => {
    const { headerText, bodyText, cancelButtonText, submitButtonText, handleSubmitClick, containerProps } = props

    return (
      <Modal
        className='-tbd'
        show={alertModal.value}
        onHide={alertModal.closeModal}
        header={<MyHeader text={headerText}/>}
        body={<MyBody text={bodyText}/>}
        footer={<MyFooter
                  cancelButtonText={cancelButtonText}
                  submitButtonText={submitButtonText}
                  handleSubmitClick={handleSubmitClick}>
                </MyFooter>}
        {...containerProps}>
      </Modal>
    )
  }

  return [ alertModal, AlertModalView ]
}
